import { render, staticRenderFns } from "./EditPersonSummaryDialog.vue?vue&type=template&id=304c375d&scoped=true&"
import script from "./EditPersonSummaryDialog.vue?vue&type=script&lang=js&"
export * from "./EditPersonSummaryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304c375d",
  null
  
)

export default component.exports